import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Nombrar el agarre",
    opening: localizedGenderNode(
      [
      "Hoy lo nombro.",
      "Es un amor unilateral que me cuesta soltar.",
      "Estoy aquí."
    ],
      [
      "Hoy lo nombro.",
      "Es un amor unilateral que me cuesta soltar.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo es especialmente fuerte este agarre?",
      "¿Qué me digo en esos momentos?",
      "¿Dónde lo siento en mi cuerpo?"
    ],
      [
      "¿Cuándo es especialmente fuerte este agarre?",
      "¿Qué me digo en esos momentos?",
      "¿Dónde lo siento en mi cuerpo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "La sensación es fuerte, pero no me define."
    ],
      [
      "La sensación es fuerte, pero no me define."
    ]
    ),
    action: localizedGenderNode(
      "una respiración + \"Estoy conmigo en esto\".",
      "una respiración + \"Estoy conmigo en esto\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "Hecho vs. fantasía",
    opening: localizedGenderNode(
      [
      "Hoy separo lo que ocurre de lo que imagino.",
      "Sin pelearlo.",
      "Me quedo conmigo."
    ],
      [
      "Hoy separo lo que ocurre de lo que imagino.",
      "Sin pelearlo.",
      "Me quedo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro hacia adentro y hacia afuera.",
      "Una respiración."
    ],
      [
      "Respiro hacia adentro y hacia afuera.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué hechos simples tengo?",
      "¿Qué agrego en mi imaginación?",
      "¿Qué me duele cuando veo el hecho?"
    ],
      [
      "¿Qué hechos simples tengo?",
      "¿Qué agrego en mi imaginación?",
      "¿Qué me duele cuando veo el hecho?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un hecho no cancela la emoción."
    ],
      [
      "Un hecho no cancela la emoción."
    ]
    ),
    action: localizedGenderNode(
      "escribir solo un hecho.",
      "escribir solo un hecho."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Lo que busco allí",
    opening: localizedGenderNode(
      [
      "Hoy miro lo que busco en este amor.",
      "Sin reducirlo.",
      "Estoy aquí."
    ],
      [
      "Hoy miro lo que busco en este amor.",
      "Sin reducirlo.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Noto mi pecho.",
      "Una respiración."
    ],
      [
      "Noto mi pecho.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué sensación quiero recibir allí?",
      "¿Qué quiero sentir sobre mí?",
      "¿Qué temo perder?"
    ],
      [
      "¿Qué sensación quiero recibir allí?",
      "¿Qué quiero sentir sobre mí?",
      "¿Qué temo perder?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Mi necesidad es real, aunque la dirección duela."
    ],
      [
      "Mi necesidad es real, aunque la dirección duela."
    ]
    ),
    action: localizedGenderNode(
      "una frase corta de necesidad.",
      "una frase corta de necesidad."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "El bucle interno",
    opening: localizedGenderNode(
      [
      "Hoy reconozco el bucle del anhelo.",
      "Solo lo noto.",
      "Me quedo conmigo."
    ],
      [
      "Hoy reconozco el bucle del anhelo.",
      "Solo lo noto.",
      "Me quedo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Siento mi forma de sentarme.",
      "Una respiración."
    ],
      [
      "Siento mi forma de sentarme.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cómo suele empezar este bucle?",
      "¿Qué lo mantiene vivo?",
      "¿Dónde puedo pausar un momento pequeño?"
    ],
      [
      "¿Cómo suele empezar este bucle?",
      "¿Qué lo mantiene vivo?",
      "¿Dónde puedo pausar un momento pequeño?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un bucle puede incluir una pausa pequeña."
    ],
      [
      "Un bucle puede incluir una pausa pequeña."
    ]
    ),
    action: localizedGenderNode(
      "una pausa de 10 segundos una vez.",
      "una pausa de 10 segundos una vez."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "Un límite interno",
    opening: localizedGenderNode(
      [
      "Hoy reviso dónde cruzo un límite conmigo.",
      "Sin culpa.",
      "Estoy aquí."
    ],
      [
      "Hoy reviso dónde cruzo un límite conmigo.",
      "Sin culpa.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pongo una mano en el pecho.",
      "Una respiración."
    ],
      [
      "Pongo una mano en el pecho.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué hago que profundiza el dolor?",
      "¿Qué límite pequeño puedo poner hoy?",
      "¿Qué temo si lo pongo?"
    ],
      [
      "¿Qué hago que profundiza el dolor?",
      "¿Qué límite pequeño puedo poner hoy?",
      "¿Qué temo si lo pongo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un límite pequeño es una protección suave."
    ],
      [
      "Un límite pequeño es una protección suave."
    ]
    ),
    action: localizedGenderNode(
      "una frase interna de límite.",
      "una frase interna de límite."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Disparadores",
    opening: localizedGenderNode(
      [
      "Hoy noto qué me activa alrededor de este amor.",
      "Solo lo noto.",
      "Me quedo conmigo."
    ],
      [
      "Hoy noto qué me activa alrededor de este amor.",
      "Solo lo noto.",
      "Me quedo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Noto mi respiración.",
      "Una respiración."
    ],
      [
      "Noto mi respiración.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué me activa más? (lugar/canción/tiempo)",
      "¿Qué emoción sube de inmediato?",
      "¿Qué necesito en ese momento?"
    ],
      [
      "¿Qué me activa más? (lugar/canción/tiempo)",
      "¿Qué emoción sube de inmediato?",
      "¿Qué necesito en ese momento?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cuando noto un disparador no estoy solo/a en él."
    ],
      [
      "Cuando noto un disparador no estoy solo/a en él."
    ]
    ),
    action: localizedGenderNode(
      "una mano en el pecho cuando sube.",
      "una mano en el pecho cuando sube."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "La parte que espera",
    opening: localizedGenderNode(
      [
      "Hoy doy espacio a la parte que espera.",
      "Sin descartarla.",
      "Estoy aquí."
    ],
      [
      "Hoy doy espacio a la parte que espera.",
      "Sin descartarla.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Ablando los hombros.",
      "Una respiración."
    ],
      [
      "Ablando los hombros.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué es bello en mi esperanza?",
      "¿Qué es difícil en esta esperanza?",
      "¿Qué quiero proteger?"
    ],
      [
      "¿Qué es bello en mi esperanza?",
      "¿Qué es difícil en esta esperanza?",
      "¿Qué quiero proteger?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Mi esperanza merece suavidad."
    ],
      [
      "Mi esperanza merece suavidad."
    ]
    ),
    action: localizedGenderNode(
      "una frase suave para la esperanza.",
      "una frase suave para la esperanza."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "La parte que se duele",
    opening: localizedGenderNode(
      [
      "Hoy permito que el duelo esté aquí.",
      "No para hundirme en él.",
      "Me quedo conmigo."
    ],
      [
      "Hoy permito que el duelo esté aquí.",
      "No para hundirme en él.",
      "Me quedo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Noto mis ojos y mi respiración.",
      "Una respiración."
    ],
      [
      "Noto mis ojos y mi respiración.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué estoy lamentando aquí?",
      "¿Qué quería dar?",
      "¿Qué quería recibir?"
    ],
      [
      "¿Qué estoy lamentando aquí?",
      "¿Qué quería dar?",
      "¿Qué quería recibir?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "El duelo es amor sin lugar donde ir."
    ],
      [
      "El duelo es amor sin lugar donde ir."
    ]
    ),
    action: localizedGenderNode(
      "una respiración con el duelo.",
      "una respiración con el duelo."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Cómo toca mi valor",
    opening: localizedGenderNode(
      [
      "Hoy reviso cómo toca mi valor.",
      "Sin juzgar.",
      "Estoy aquí."
    ],
      [
      "Hoy reviso cómo toca mi valor.",
      "Sin juzgar.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Suavizo la mandíbula.",
      "Una respiración."
    ],
      [
      "Suavizo la mandíbula.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué me digo sobre mí en esto?",
      "¿Qué le diría a un amigo aquí?",
      "¿Qué quiero creer sobre mí?"
    ],
      [
      "¿Qué me digo sobre mí en esto?",
      "¿Qué le diría a un amigo aquí?",
      "¿Qué quiero creer sobre mí?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Mi valor no depende de una respuesta externa."
    ],
      [
      "Mi valor no depende de una respuesta externa."
    ]
    ),
    action: localizedGenderNode(
      "una frase de valor para mí.",
      "una frase de valor para mí."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Una petición para mí",
    opening: localizedGenderNode(
      [
      "Hoy me doy una petición clara.",
      "No una exigencia.",
      "Me quedo conmigo."
    ],
      [
      "Hoy me doy una petición clara.",
      "No una exigencia.",
      "Me quedo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Siento el abdomen aflojar un poco.",
      "Una respiración."
    ],
      [
      "Siento el abdomen aflojar un poco.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuál es mi petición más importante ahora?",
      "¿Cómo decirla en una sola frase?",
      "¿Qué estoy dispuesto/a a darme a cambio?"
    ],
      [
      "¿Cuál es mi petición más importante ahora?",
      "¿Cómo decirla en una sola frase?",
      "¿Qué estoy dispuesto/a a darme a cambio?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una petición es un ancla pequeña."
    ],
      [
      "Una petición es un ancla pequeña."
    ]
    ),
    action: localizedGenderNode(
      "escribir la petición en una frase corta.",
      "escribir la petición en una frase corta."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Un pequeño cambio",
    opening: localizedGenderNode(
      [
      "Hoy elijo un pequeño cambio dentro del día.",
      "No una revolución.",
      "Estoy aquí."
    ],
      [
      "Hoy elijo un pequeño cambio dentro del día.",
      "No una revolución.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Noto un punto de contacto en mi cuerpo.",
      "Una respiración."
    ],
      [
      "Noto un punto de contacto en mi cuerpo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué pequeño cambio estoy dispuesto/a a probar hoy?",
      "¿Cuándo es más fácil probarlo?",
      "¿Qué me recordará suavemente elegirlo?"
    ],
      [
      "¿Qué pequeño cambio estoy dispuesto/a a probar hoy?",
      "¿Cuándo es más fácil probarlo?",
      "¿Qué me recordará suavemente elegirlo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un pequeño cambio es un movimiento suave."
    ],
      [
      "Un pequeño cambio es un movimiento suave."
    ]
    ),
    action: localizedGenderNode(
      "elegir un momento para probarlo.",
      "elegir un momento para probarlo."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Quedarme conmigo",
    opening: localizedGenderNode(
      [
      "Hoy noto el momento en que me quedo conmigo.",
      "En lugar de perseguir.",
      "Estoy aquí."
    ],
      [
      "Hoy noto el momento en que me quedo conmigo.",
      "En lugar de perseguir.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Escucho mi respiración.",
      "Una respiración."
    ],
      [
      "Escucho mi respiración.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo tiendo a perseguir en mi mente?",
      "¿Cómo se ve un momento de quedarme conmigo?",
      "¿Cómo me siento después de eso?"
    ],
      [
      "¿Cuándo tiendo a perseguir en mi mente?",
      "¿Cómo se ve un momento de quedarme conmigo?",
      "¿Cómo me siento después de eso?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Quedarme conmigo es una elección."
    ],
      [
      "Quedarme conmigo es una elección."
    ]
    ),
    action: localizedGenderNode(
      "decir en mi corazón \"Estoy conmigo\" una vez.",
      "decir en mi corazón \"Estoy conmigo\" una vez."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Una pequeña nueva dirección",
    opening: localizedGenderNode(
      [
      "Hoy hago espacio para una pequeña nueva dirección.",
      "No lejos, solo posible.",
      "Estoy aquí."
    ],
      [
      "Hoy hago espacio para una pequeña nueva dirección.",
      "No lejos, solo posible.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Siento la espalda apoyada.",
      "Una respiración."
    ],
      [
      "Siento la espalda apoyada.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué quiero sentir más en la vida?",
      "¿Qué pequeño valor quiero vivir hoy?",
      "¿Qué pequeña señal muestra que está ocurriendo?"
    ],
      [
      "¿Qué quiero sentir más en la vida?",
      "¿Qué pequeño valor quiero vivir hoy?",
      "¿Qué pequeña señal muestra que está ocurriendo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una pequeña dirección puede ser suficiente por hoy."
    ],
      [
      "Una pequeña dirección puede ser suficiente por hoy."
    ]
    ),
    action: localizedGenderNode(
      "una frase corta de valor.",
      "una frase corta de valor."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Cierre suave",
    opening: localizedGenderNode(
      [
      "Hoy cierro el viaje con suavidad.",
      "Sin forzar un final perfecto.",
      "Estoy aquí."
    ],
      [
      "Hoy cierro el viaje con suavidad.",
      "Sin forzar un final perfecto.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué aprendí sobre este amor?",
      "¿Cuál es la señal temprana de que vuelvo al bucle?",
      "Frase de regreso para el momento antes - ¿qué me digo?"
    ],
      [
      "¿Qué aprendí sobre este amor?",
      "¿Cuál es la señal temprana de que vuelvo al bucle?",
      "Frase de regreso para el momento antes - ¿qué me digo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Puedo amar y aun así quedarme conmigo."
    ],
      [
      "Puedo amar y aun así quedarme conmigo."
    ]
    ),
    action: localizedGenderNode(
      "una respiración antes de responder.",
      "una respiración antes de responder."
    ),
  },
].map(buildNormalizedDay);

export const gettingStuckOnAnImpossibleOneSidedLoveBlueprintEs = buildNormalizedPilotBlueprint({
  id: "getting_stuck_on_an_impossible_one_sided_love_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "getting_stuck_on_an_impossible_one_sided_love",
  category: "love_and_relationships",
  journeyName: {
    he: "אהבה בלתי אפשרית / חד-צדדית",
    en: "Getting stuck in an impossible one-sided love",
    es: "Quedarme atrapado/a en un amor imposible y unilateral",
  },
  days,
});

export default gettingStuckOnAnImpossibleOneSidedLoveBlueprintEs;
